import { Card, Col, Row, Table } from "antd";
import React from "react";

function OwnerPortals({ data }) {

console.log(data,"email")

  const ownerPortal = "Inactive" || "";
  const twoFactorsStatus = "Not Enrolled" || "";
  const ownerEmail = data?.ownerEmail ? data?.ownerEmail[0] : null;

  const dataSource = [
    {
      key: 1,
      ownerEmail: ownerEmail, 
      ownerPortal,
      twoFactorsStatus,
    },
  ];


  const columns = [
    {
      title: 'Owner Email',
      dataIndex: 'ownerEmail',
      key: 'ownerEmail',
      render: () => <span>{ownerEmail}</span>,
    },
    {
      title: 'Owner Portal',
      dataIndex: 'ownerPortal',
      key: 'ownerPortal',
      render: () => <span>{ownerPortal}</span>,
    },
    {
      title: 'Two Factor Status',
      dataIndex: 'twoFactorsStatus',
      key: 'twoFactorsStatus',
      render: () => <span>{twoFactorsStatus}</span>,
    },
  ];

  return (
    <Card title="Owner Portals">
      <Row>
        <Col span={24} className="table-container">
          <Table columns={columns} dataSource={dataSource} />
        </Col>
      </Row>
    </Card>
  );
}

export default OwnerPortals;
